// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"e1fd9929","232":"d9e5dbb8","237":"4e4da19e","357":"c9c49a70","415":"4d6acbeb","526":"1a222975","753":"cda04cb3","787":"1ed0c42c","854":"b1549e7f","872":"0700fdd5"}[chunkId] + ".chunk.js";
};